import {Route, Switch} from 'react-router';

import {appRoute} from '../../../app-route';
import {ErrorPage404} from '../../error/page-404/page-404';

import {NewReviewItemPageContent} from './new-review-item-page-content/new-review-item-page-content';
import {ReviewActivityProvider} from './review-activity-provider/review-activity-provider';
import {ReviewListPageContent} from './review-list-page-content/review-list-page-content';
import {ReviewsStateProvider} from './reviews-state/reviews-state-provider';

export function Reviews(): JSX.Element {
    return (
        <Switch>
            <Route exact path={appRoute.reviewsManagementReviewItem.path}>
                <ReviewActivityProvider expandedReplies>
                    <ReviewsStateProvider>
                        <NewReviewItemPageContent />
                    </ReviewsStateProvider>
                </ReviewActivityProvider>
            </Route>

            <Route exact path={appRoute.reviewsManagementReviews.path}>
                <ReviewsStateProvider>
                    <ReviewListPageContent />
                </ReviewsStateProvider>
            </Route>

            <Route component={ErrorPage404} />
        </Switch>
    );
}
